import {createSelector} from 'reselect';
import {getCurrency, getLocaleFromSiteDataV2} from '../../selectors';

const getRebrandedTrustlyAttributes = createSelector(
  [getCurrency, getLocaleFromSiteDataV2],
  (currency, locale) => {
    if (locale === 'en_GB' && currency === 'GBP') {
      return {
        helpText: null,
      };
    }
    
    return {
      helpText: 'checkout.payment.method.help.text.trustly',
    };
  },
);

export default getRebrandedTrustlyAttributes;
